import { startCase } from 'lodash';
import { useFilterSearchParam } from 'common/hooks/useFilterSearchParam';
import { AUTHORIZATION_STATUSES_TEXT, AUTHORIZATION_STATUSES, OPEN_AUTHORIZATION_PAGE_STATUSES } from 'common/Status/authorizationConstants';
import useContractedProgramOptions from './useContractedProgramOptions';
import useAssignedToOptions from './useAssignedToOptions';

const useServiceAuthorizationFilters = ({ authorizationStatus }) => {
  const [requestId, setRequestId] = useFilterSearchParam('request_id', undefined);
  const [clientName, setClientName] = useFilterSearchParam('client_name', undefined);
  const [statusValue, setStatus] = useFilterSearchParam('status', undefined);
  const [contractedPrograms, setContractedPrograms] = useFilterSearchParam(
    'contracted_programs',
    undefined,
  );
  const [primaryHealthInsuranceMemberId, setPrimaryHealthInsuranceMemberId] = useFilterSearchParam(
    'primary_health_insurance_member_id',
    undefined,
  );
  const [assignedTo, setAssignedTo] = useFilterSearchParam('assigned_to', undefined);
  const [requestType, setRequestType] = useFilterSearchParam('request_type', undefined);

  let statusOptions = [
    {
      label: startCase(AUTHORIZATION_STATUSES_TEXT.open),
      value: AUTHORIZATION_STATUSES.open,
    },
    {
      label: startCase(AUTHORIZATION_STATUSES_TEXT.inReview),
      value: AUTHORIZATION_STATUSES.inReview,
    },
    {
      label: startCase(AUTHORIZATION_STATUSES_TEXT.accepted),
      value: AUTHORIZATION_STATUSES.accepted,
    },
    {
      label: startCase(AUTHORIZATION_STATUSES_TEXT.autoAccepted),
      value: AUTHORIZATION_STATUSES.autoAccepted,
    },
    {
      label: startCase(AUTHORIZATION_STATUSES_TEXT.rejected),
      value: AUTHORIZATION_STATUSES.rejected,
    },
  ];

  if (authorizationStatus === OPEN_AUTHORIZATION_PAGE_STATUSES) {
    statusOptions = statusOptions.filter((option) => option.value === AUTHORIZATION_STATUSES.open ||
      option.value === AUTHORIZATION_STATUSES.inReview);
  } else if (authorizationStatus === AUTHORIZATION_STATUSES.accepted) {
    statusOptions = statusOptions.filter((option) => option.value === AUTHORIZATION_STATUSES.accepted ||
      option.value === AUTHORIZATION_STATUSES.autoAccepted);
  }

  const assignedToOptions = useAssignedToOptions();
  const contractedProgramOptions = useContractedProgramOptions();

  const requestTypeOptions = [
    { label: 'Authorization', value: 'false' },
    { label: 'Update', value: 'true' },
  ];

  const resetFilters = () => {
    setRequestId(undefined);
    setClientName(undefined);
    setStatus(undefined);
    setContractedPrograms(undefined);
    setPrimaryHealthInsuranceMemberId(undefined);
    setAssignedTo(undefined);
    setRequestType(undefined);
  };

  const isFiltered = !!requestId ||
    !!clientName ||
    !!statusValue ||
    !!contractedPrograms ||
    !!primaryHealthInsuranceMemberId ||
    !!assignedTo ||
    !!requestType;

  return ({
    filterValues: {
      requestId,
      clientName,
      status: statusValue,
      contractedPrograms,
      primaryHealthInsuranceMemberId,
      assignedTo,
      requestType,
    },
    filterOptions: {
      contractedProgram: contractedProgramOptions,
      status: statusOptions,
      assignedTo: assignedToOptions,
      requestType: requestTypeOptions,
    },
    resetFilters,
    isFiltered,
    setRequestIdFilter: setRequestId,
    setClientNameFilter: setClientName,
    setStatusFilter: setStatus,
    setContractedProgramFilter: setContractedPrograms,
    setPrimaryHealthInsuranceMemberIdFilter: setPrimaryHealthInsuranceMemberId,
    setAssignedToFilter: setAssignedTo,
    setRequestTypeFilter: setRequestType,
  });
};

export default useServiceAuthorizationFilters;
